'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'fill-drip';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f576';
var svgPathData = ['M18.9 304l419.7 0L272.6 470.1c-31.2 31.2-81.9 31.2-113.1 0L41.9 352.6C28.4 339 20.7 321.7 18.9 304zM464 448c0-3.4 1.2-9.4 4.4-18c3-8.3 7.4-17.7 12.5-27.6c9.9-19.2 22-39.1 31.2-53.4c9.1 14.3 21.3 34.1 31.2 53.4c5.1 9.9 9.4 19.3 12.5 27.6c3.2 8.6 4.4 14.6 4.4 18c0 26.5-21.5 48-48 48s-48-21.5-48-48z', 'M34.3 2.3c3.1-3.1 8.2-3.1 11.3 0L151 107.7l81.4-81.4c21.9-21.9 57.3-21.9 79.2 0L485.7 200.4c21.9 21.9 21.9 57.3 0 79.2L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L139.7 119 34.3 13.7c-3.1-3.1-3.1-8.2 0-11.3zm208 219.3L151 130.3 41.9 239.4C28.4 253 20.7 270.3 18.9 288l435.7 0 19.7-19.7c15.6-15.6 15.6-40.9 0-56.6L300.3 37.7c-15.6-15.6-40.9-15.6-56.6 0L162.3 119l91.3 91.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0zM18.9 304c1.8 17.7 9.4 35 23 48.6L159.4 470.1c31.2 31.2 81.9 31.2 113.1 0L438.6 304 18.9 304zM560 448c0-3.4-1.2-9.4-4.4-18c-3-8.3-7.4-17.7-12.5-27.6c-9.9-19.2-22-39.1-31.2-53.4c-9.1 14.3-21.3 34.1-31.2 53.4c-5.1 9.9-9.4 19.3-12.5 27.6c-3.2 8.6-4.4 14.6-4.4 18c0 26.5 21.5 48 48 48s48-21.5 48-48zm16 0c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFillDrip = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;